module.exports = __webpack_public_path__ + "static/mixed-790e4d6e0393bbaa723b46af468eca31.svg";